function P_Portfolio() {
  document.title = 'Portfolio | iamcatraz'
  return <></>
}

export default P_Portfolio
